<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-text-field
          v-model="searchValue"
          label="搜尋"
          :color="Theme.GREEN"
          placeholder="查詢商品"
        ></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn
          class="mr-2"
          :color="Theme.GREEN"
          dark
          @click.prevent="searchEvent"
          >搜尋</v-btn
        >
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
      <v-flex>
        <v-spacer></v-spacer>
        <v-btn
          style="float: right;"
          :color="Theme.PINK"
          dark
          @click.prevent="addNew"
          >新增</v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <table-view
          :items="list"
          :columnKeys="getColumnKeys"
          :pagination="pagination"
          :loading="loading"
          :counters="counterList"
          @changePage="changePage"
          @cellEvent="cellEvent"
        />
      </v-flex>
    </v-layout>

    <product-detail
      :title="editView.title"
      :visible="editView.visible"
      :item-detail="editView.item"
      :show-cancel="editView.showCancel"
      :counters="editView.counters"
      @cancelEvent="editView.cancelEvent"
      @confirmEvent="editView.confirmEvent"
    />
  </v-container>
</template>

<script>
import TableView from "@/components/TableView";
import ProductDetail from "./ProductDetail";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";

export default {
  name: "product",
  components: {
    TableView,
    ProductDetail,
  },
  mixins: [common],
  data() {
    return {
      loading: false,
      searchValue: "",
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list: [],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        counters: null,
        confirmEvent: () => {},
        cancelEvent: () => {},
      },
      counterList: [],
    };
  },
  async created() {
    await this.loadCounterData();
    await this.loadData();
  },
  computed: {
    ...mapGetters([]),
    getColumnKeys() {
      return [
        {
          value: "edit",
          text: "編輯",
          isEvent: true,
          color: this.Theme.GREEN,
          sortable: false,
        },
        { value: "productId", text: "商品編號", sortable: true },
        {
          value: "type",
          text: "分類",
          sortable: false,
          options: this.getProductTypes,
        },
        { value: "name", text: "商品名稱", sortable: true },
        { value: "color", text: "顏色", sortable: false },
        {
          value: "category",
          text: "類別",
          sortable: false,
          options: this.getProductCategoryList,
        },
        { value: "productGroup", text: "系列", sortable: false },
        { value: "sort", text: "排序", sortable: false },
        { value: "price", text: "售價", sortable: false },
        {
          value: "counter",
          text: "櫃位",
          sortable: false,
          options: this.counterList,
        },
        {
          value: "enable",
          text: "上架狀態",
          sortable: false,
          options: this.getProductEnable,
        },
        {
          value: "delete",
          text: "刪除",
          isEvent: true,
          color: this.Theme.YELLOW,
          sortable: false,
        },
      ];
    },
  },
  methods: {
    ...mapActions(["getProductList", "deleteProductInfo", "getCounterList"]),
    async loadCounterData() {
      const res = await this.getCounterList();
      if (res.data.code === 0) {
        this.counterList = res.data.body;
      }
    },
    async loadData() {
      try {
        this.loading = true;
        const res = await this.getProductList({
          pageIndex: this.pagination.page,
          limit: this.pagination.itemsPerPage,
          searchValue: this.searchValue,
          admin: "1",
          type: -1,
        });

        if (res.data.code === 0) {
          let copyList = res.data.body.list;
          for (let i = 0; i < copyList.length; i++) {
            let element = copyList[i];

            if (element.counter) {
              const counterArray = element.counter.split(",");
              const counters =
                counterArray.length > 1
                  ? JSON.parse(element.counter)
                  : [element.counter];

              let copyCounters = new Set();
              for (let j = 0; j < counters.length; j++) {
                let counterString = counters[j];
                counterString = counterString.replaceAll(
                  /([.?*+^$[\]\\(){}])/g,
                  ""
                );
                counterString = counterString.replaceAll(/"/g, "");
                counterString = counterString.replaceAll("[]", "");
                if (counterString) {
                  copyCounters.add(counterString);
                }
              }
              element.counter = Array.from(copyCounters);
            } else {
              element.counter = [];
            }
          }
          this.list = copyList;
          this.pagination.totalItems = res.data.body.header.totalCount;
          console.log(`getProductList ${JSON.stringify(copyList)} `);
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page) {
      this.pagination.page = page.page;
      if (page.itemsPerPage === -1) {
        this.pagination.itemsPerPage = 1000;
      } else {
        this.pagination.itemsPerPage = page.itemsPerPage;
      }
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell) {
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === "delete") {
        this.showAlert({
          title: "提示",
          content: "是否確定要刪除此商品？",
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          },
        });
      } else {
        if (!cell.item.imageList) {
          cell.item.imageList = [];
        }
        if (!cell.item.linkList) {
          cell.item.linkList = [];
        }
        this.editView.title = cell.key === "add" ? "新增商品" : "修改商品";
        this.editView.item = JSON.parse(JSON.stringify(cell.item));
        this.editView.counters = this.counterList || [];
        this.editView.visible = true;
        this.editView.cancelEvent = () => {
          this.editView.visible = false;
        };
        this.editView.confirmEvent = () => {
          this.editView.visible = false;
          this.loadData();
        };
      }
    },
    searchEvent() {
      this.loadData();
    },
    reset() {
      this.searchValue = "";
      this.loadData();
    },
    async deleteEvent(item) {
      const res = await this.deleteProductInfo({
        productId: item.productId,
      });

      if (res.data.code === 0) {
        this.reset();
      }
    },
    addNew() {
      this.cellEvent({
        key: "add",
        item: {
          productId: "",
          name: "",
          category: 0,
          color: "",
          productGroup: "",
          disposable: 0,
          baseCurve: "",
          waterContent: "",
          diameter: "",
          price: 0,
          unit: "",
          introduction: "",
          content: "",
          smallURL: "",
          smallHoverURL: "",
          largeURL: "",
          counter: [],
          largeHoverURL: "",
        },
      });
    },
  },
};
</script>

<style scoped></style>
